import { createFileRoute } from '@tanstack/react-router';
import MinhasSolicitacoes from '../../-components/opcoes/minhas-solicitacoes';

export const Route = createFileRoute(
  '/__authenticated/comercial/produto/clientes/hibridos/$id/minhas-solicitacoes',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { cliente } = Route.useRouteContext();

  return <MinhasSolicitacoes cliente={cliente} />;
}
